import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";
import { SCREEN_MODES } from "../../resources/enums";

interface IInitialState {
    SHOW_TOP_LOADING: boolean;
    SCREEN_MODE: SCREEN_MODES;
}

const initialState: IInitialState = {
    SHOW_TOP_LOADING: false,
    SCREEN_MODE: SCREEN_MODES.LIGHT
}

const globalSlice = createSlice({
    name: "globals",
    initialState,
    reducers: {
        SHOW_TOP_LOADING: (state) => {
            state.SHOW_TOP_LOADING = true;
        },
        HIDE_TOP_LOADING: (state) => {
            state.SHOW_TOP_LOADING = false;
        },
        SET_SCREEN_MODE: (state, action: PayloadAction<SCREEN_MODES>) => {
            state.SCREEN_MODE = action.payload;
        }
    }
});

export const getTopLoadingState = (state: RootState): boolean => {
    return !!state?.globals?.SHOW_TOP_LOADING;
};

export const getScreenMode = (state: RootState): SCREEN_MODES => {
    return state?.globals?.SCREEN_MODE;
};

export const { SHOW_TOP_LOADING, HIDE_TOP_LOADING, SET_SCREEN_MODE } = globalSlice.actions;
export default globalSlice.reducer;